import PropTypes from 'prop-types';

const SpecsManagerMenuItem = ({ getComponent, onClick, children = null }) => {
  const DropdownMenuItem = getComponent('DropdownMenuItem');

  return <DropdownMenuItem onClick={onClick}>{children || 'Manage Specs'}</DropdownMenuItem>;
};

SpecsManagerMenuItem.propTypes = {
  getComponent: PropTypes.func.isRequired,
  children: PropTypes.node,
  onClick: PropTypes.func.isRequired,
};

export default SpecsManagerMenuItem;
